<template>
	<div v-if="blok.content.logo?.filename" :id="blok.uuid" class="flex flex-col">
		<nuxt-link
			class="flex flex-col"
			:to="`/${blok.full_slug}`"
			:aria-label="blok.name"
		>
			<div class="relative aspect-square h-auto w-full rounded">
				<nuxt-picture
					class="relative block size-full"
					:src="properties.blok.content.image?.filename"
					provider="storyblok"
					preload
					width="254"
					sizes="xs:100vw sm:254px md:254px lg:254px xl:512px 2xl:512px"
					:img-attrs="{
						class: 'w-full h-full object-cover',
					}"
					:alt="blok.content.image?.alt"
				/>

				<span
					role="presentation"
					class="absolute inset-0 rounded bg-black/20"
				></span>

				<nuxt-picture
					class="absolute top-1/2 left-1/2 block h-auto w-32 -translate-1/2 lg:w-1/2"
					:src="blok.content.logo?.filename"
					provider="storyblok"
					preload
					width="254"
					sizes="xs:100vw sm:254px md:254px lg:254px xl:254px 2xl:254px"
					:img-attrs="{
						class: 'w-full',
					}"
					:alt="blok.content.logo?.alt"
					:placeholder="[220, 50, 100, 100]"
				/>
			</div>

			<div class="mt-2">
				<p class="font-sans-caption font-bold">{{ blok.content.title }}</p>
			</div>

			<div>
				<p class="line-clamp-4 font-sans text-base font-normal text-gray-500">
					{{ intro }}
				</p>
			</div>
		</nuxt-link>
	</div>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

const properties = defineProps<{
	blok: ISbStoryData;
}>();

const intro = computed(() => {
	if (properties.blok.content.introduction !== "") {
		return properties.blok.content.introduction;
	}
	return properties.blok.content.short_description;
});
</script>
